<div class="customer-info-form-container">
  <div class="customer-info-form" [formGroup]="form">
    <div class="profile-completion-intro">
      <div class="header">
        <span>{{ 'popins.profile-completion.title' | translate }}</span>
      </div>
      <p class="info">{{ 'popins.profile-completion.info' | translate }}</p>
      @if (globalError) {
        <div class="error-message global">{{ globalError }}</div>
      }
    </div>

    <div class="body">
      <!-- COLONNE 1 : IDENTITÉ -->
      <div class="customer-info-form-column">
        <div class="common-form-container">
          <div class="header">
            <span [innerHTML]="'customer-info-form.civility-form.title' | translate"></span>
          </div>

          <!-- Civilité -->
          <div class="input-row">
            <div class="form-input">
              <div class="label-row">
                <span class="label">{{ 'popins.signup.civility' | translate }}</span
                ><span class="required">*</span>
              </div>
              <div class="radio-inputs sentry-mask">
                <div class="radio-option" *ngFor="let civilityValue of civilityValues">
                  <p-radioButton
                    [inputId]="'ciam-completion-' + civilityValue.value"
                    formControlName="honorificPrefix"
                    [value]="civilityValue.value" />
                  <label [for]="'ciam-completion-' + civilityValue.value">{{ civilityValue.name }}</label>
                </div>
              </div>
              @if (hasError('honorificPrefix')) {
                <div class="error-message">{{ 'popins.profile-completion.errors.required' | translate }}</div>
              }
            </div>
          </div>

          <!-- Nom -->
          <div class="input-row">
            <div class="form-input">
              <div class="label-row">
                <span class="label">{{ 'popins.signup.label1' | translate }}</span
                ><span class="required">*</span>
              </div>
              <div class="input">
                <input
                  class="text-input sentry-mask"
                  type="text"
                  pInputText
                  formControlName="lastName"
                  name="input-completion-last-name"
                  id="input-completion-last-name" />
              </div>
              @if (hasError('lastName')) {
                <div class="error-message">{{ 'popins.profile-completion.errors.required' | translate }}</div>
              }
            </div>
          </div>

          <!-- Prénom -->
          <div class="input-row">
            <div class="form-input">
              <div class="label-row">
                <span class="label">{{ 'popins.signup.label2' | translate }}</span
                ><span class="required">*</span>
              </div>
              <div class="input">
                <input
                  class="text-input sentry-mask"
                  type="text"
                  pInputText
                  formControlName="firstName"
                  name="input-completion-name"
                  id="input-completion-name" />
              </div>
              @if (hasError('firstName')) {
                <div class="error-message">{{ 'popins.profile-completion.errors.required' | translate }}</div>
              }
            </div>
          </div>

          <!-- Téléphone -->
          <div class="input-row">
            <div class="form-input">
              <div class="label-row">
                <span class="label">{{ 'popins.signup.labelPhone' | translate }}</span
                ><span class="required">*</span>
              </div>
              <div class="input">
                <input
                  class="text-input sentry-mask"
                  type="text"
                  pInputText
                  formControlName="phoneNumber"
                  name="input-completion-phone"
                  id="input-completion-phone" />
              </div>
              @if (hasError('phoneNumber')) {
                <div class="error-message">{{ 'popins.signup.errors.phone' | translate }}</div>
              }
            </div>
          </div>
        </div>
      </div>

      <!-- COLONNE 2 : ADRESSE -->
      <div class="customer-info-form-column">
        <div class="common-form-container">
          <div class="header">
            <span [innerHTML]="'customer-info-form.address-form.title' | translate"></span>
          </div>

          <!-- Adresse -->
          <div class="input-row">
            <div class="form-input">
              <div class="label-row">
                <span class="label">{{ 'popins.signup.label7' | translate }}</span
                ><span class="required">*</span>
              </div>
              <div class="input">
                <input
                  class="text-input sentry-mask"
                  type="text"
                  pInputText
                  formControlName="addressLine1"
                  name="input-completion-adress"
                  id="input-completion-adress" />
              </div>
              @if (hasError('addressLine1')) {
                <div class="error-message">{{ 'popins.profile-completion.errors.required' | translate }}</div>
              }
            </div>
          </div>

          <!-- Complément : optionnel, un pavillon n'a ni étage ni boîte aux lettres -->
          <div class="input-row">
            <div class="form-input">
              <div class="label-row">
                <span class="label">{{ 'popins.signup.label8' | translate }}</span>
              </div>
              <div class="input">
                <input
                  class="text-input sentry-mask"
                  type="text"
                  pInputText
                  formControlName="addressComplement"
                  name="input-completion-adress-complement"
                  id="input-completion-adress-complement" />
              </div>
            </div>
          </div>

          <!-- Code postal / Ville -->
          <div class="input-row">
            <div class="form-input small">
              <div class="label-row">
                <span class="label">{{ 'popins.signup.label9' | translate }}</span
                ><span class="required">*</span>
              </div>
              <div class="input">
                <input
                  class="text-input sentry-mask"
                  type="text"
                  pInputText
                  formControlName="postalCode"
                  name="input-completion-zipcode"
                  id="input-completion-zipcode" />
              </div>
              @if (hasError('postalCode')) {
                <div class="error-message">{{ 'popins.signup.errors.postalCode' | translate }}</div>
              }
            </div>

            <div class="form-input">
              <div class="label-row">
                <span class="label">{{ 'popins.signup.label10' | translate }}</span
                ><span class="required">*</span>
              </div>
              <div class="input">
                <input
                  class="text-input sentry-mask"
                  type="text"
                  pInputText
                  formControlName="city"
                  name="input-completion-city"
                  id="input-completion-city" />
              </div>
              @if (hasError('city')) {
                <div class="error-message">{{ 'popins.profile-completion.errors.required' | translate }}</div>
              }
            </div>
          </div>

          <!-- Pays -->
          <div class="input-row">
            <div class="form-input">
              <div class="label-row">
                <span class="label">{{ 'popins.signup.label11' | translate }}</span
                ><span class="required">*</span>
              </div>
              <div class="input sentry-mask">
                <p-dropdown
                  [options]="countries"
                  formControlName="country"
                  optionLabel="label"
                  optionValue="value"
                  name="input-completion-state"
                  id="input-completion-state"
                  [placeholder]="'popins.signup.label11' | translate">
                </p-dropdown>
              </div>
              @if (hasError('country')) {
                <div class="error-message">{{ 'popins.profile-completion.errors.required' | translate }}</div>
              }
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- FOOTER : pas d'annulation, la modale est bloquante tant que la fiche est incomplète -->
    <div class="footer">
      <div class="actions">
        <ng-casto-button
          class="primary"
          [loading]="isLoading"
          (click)="submit()"
          [label]="'popins.signup.btn' | translate"
          [disabled]="form.invalid">
        </ng-casto-button>
      </div>
    </div>
  </div>
</div>
